import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router";
import blackLogo from "../../src/black-logo.png";

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation(); // This hook gives us the current URL path
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Function to determine if a link is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  // Function to get the appropriate class for links
  const getLinkClass = (path) => {
    const baseClass = "text-sm uppercase tracking-wider";
    const defaultClass = "text-secondary hover:bg-secondary hover:text-white py-1 px-2 rounded-md transition-colors";
    const activeClass = "bg-secondary text-white py-1 px-2 rounded-md"; // Active style matches hover style
    
    return `${baseClass} ${isActive(path) ? activeClass : defaultClass}`;
  };

  // Function to get mobile link class
  const getMobileLinkClass = (path) => {
    const baseClass = "text-sm uppercase tracking-wider py-2";
    const defaultClass = "text-primary hover:text-secondary transition-colors";
    const activeClass = "text-secondary font-medium"; // You can adjust active style for mobile
    
    return `${baseClass} ${isActive(path) ? activeClass : defaultClass}`;
  };

  return (
    <>
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex justify-between items-center">
            {/* Logo - Responsive sizing */}
            <div className="text-xl sm:text-2xl font-serif tracking-wider text-primary flex items-center">
              <Link to='/'>
              <img src={blackLogo} alt="La Passion" className="h-12 md:h-16" />

              </Link>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-4 lg:space-x-8">
              <Link
                to="/"
                className={getLinkClass("/")}
              >
                Home
              </Link>
              <Link
                to="/properties"
                className={getLinkClass("/properties")}
              >
                Properties
              </Link>
              <Link
                to="/services"
                className={getLinkClass("/services")}
              >
                Services
              </Link>
              <Link
                to="/contact"
                className={getLinkClass("/contact")}
              >
                Contact
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden text-primary focus:outline-none"
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        <div 
          className={`md:hidden bg-white border-t border-gray-100 transition-all duration-300 overflow-hidden ${
            isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="container mx-auto px-6 py-3">
            <nav className="flex flex-col space-y-3">
              <Link
                to="/"
                className={getMobileLinkClass("/")}
              >
                Home
              </Link>
              <Link
                to="/properties"
                className={getMobileLinkClass("/properties")}
              >
                Properties
              </Link>
              <Link
                to="/services"
                className={getMobileLinkClass("/services")}
              >
                Services
              </Link>
              <Link
                to="/contact"
                className={getMobileLinkClass("/contact")}
              >
                Contact
              </Link>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
};

export default NavBar;